/**
 * The `fixedCar` field is a free-text string from the backend. When a
 * specific vehicle has been fixed to the trip it holds a car number
 * (e.g. "42"). For some trips the backend instead returns a
 * non-localized Swedish status phrase (e.g. "Bil tilldelas") which is
 * always in Swedish regardless of the user's locale. This maps known
 * raw backend phrases to a status enum so each app can localize them
 * with its own translation keys. Any value not in this map is assumed
 * to be an actual vehicle identifier and should be displayed as-is.
 */
export enum FixedCarStatus {
  PendingAssignment = 'PENDING_ASSIGNMENT',
}

const KNOWN_FIXED_CAR_STATUSES: Record<string, FixedCarStatus> = {
  'bil tilldelas': FixedCarStatus.PendingAssignment,
};

export const getFixedCarStatus = (fixedCar?: string | number): FixedCarStatus | undefined => {
  const normalized = typeof fixedCar === 'string' ? fixedCar : String(fixedCar);
  return normalized ? KNOWN_FIXED_CAR_STATUSES[normalized.trim().toLowerCase()] : undefined;
};
